

import axios from "axios";
import {
  GETCANDIDATE,
  baseURL,
} from "./type";

export const getcandidate = (data) => (dispatch) => {
  console.log(localStorage.getItem("token"));

  var config = {
    method: "post",
    // url: baseURL + "setupElectionTypes/getAll",
     url: baseURL + "/api/electioncandidates/getAll",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type:   GETCANDIDATE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};